import * as BsIcons from "react-icons/bs";
import * as MdIcons from "react-icons/md";
import * as LuIcons from "react-icons/lu";

const ReactIcons = {
  ...BsIcons,
  //   ...MdIcons,
  //   ...LuIcons,
};

export default ReactIcons;
